.styledTableHeader {
  position: sticky;
  left: 0;
  z-index: calc(var(--z-index-header-cell) + 1);
}
